import React from 'react'
import { useHorizontalTimelineContext } from '../context'
import { axisTicksSelector } from '../selectors/axis_selectors'
import { scrubberBoundsSelector } from '../selectors/scrubber_display_selectors'
import { backgroundBoundsSelector } from '../selectors/background_selectors'
import { timelineBoundsSelector, cursorSelector } from '../selectors/timeline_display_selectors'
import Background from '../components/Background'
import { Cursor } from '../types/types'
import { DragEventData } from '../types/gesture-types'
import { Marker, Timespan } from '@app-types/entity_types'

type BackgroundContainerProps = {
  markers: Marker[]
  timespans: Timespan[]
  onPanStart: (eventData: DragEventData) => void
  onPanMove: (eventData: DragEventData) => void
  onPanEnd: (eventData: DragEventData) => void
}

const BackgroundContainer: React.FC<BackgroundContainerProps> = props => {
  const { state } = useHorizontalTimelineContext()
  const { onPanStart, onPanMove, onPanEnd } = props

  const bounds = backgroundBoundsSelector(state, props)
  const cursor: Cursor = cursorSelector(state, props)
  const timelineBounds = timelineBoundsSelector(state, props)
  const offset = timelineBounds.surface.x
  const ticks = axisTicksSelector(state, props)
  const axisY = scrubberBoundsSelector(state, props).y

  const newProps = {
    ...props,
    width: bounds.width,
    height: bounds.height,
    ticks,
    axisX: 0,
    axisY,
    offset,
    onPanStart,
    onPanMove,
    onPanEnd,
    cursor,
  }

  return <Background {...newProps} />
}

export default BackgroundContainer
